import { ref as a } from "vue";
const s = a("Terms and conditions"), e = a(!1);
function n(t) {
  s.value = t;
}
function l() {
  e.value = !e.value;
}
function r() {
  e.value = !1, s.value = "";
}
export {
  s as a,
  e as m,
  r,
  n as s,
  l as t
};
//# sourceMappingURL=useModal.CgbJKM9V.js.map
